import { useState } from "react";
import { ReactComponent as FolderIcon } from "./../../../../assets/images/folder.svg";
import { ReactComponent as FolderOpenIcon } from "./../../../../assets/images/folderOpened.svg";
import { ReactComponent as ArrowDownIcon } from "./../../../../assets/images/arrowDown.svg";
import CurriculumCI from "../CurriculumCI/CurriculumCI";
import CurriculumFolderProps from "./CurriculumFolderProps";
import "./CurriculumFolder.scss";

interface IContentItem {
  _id: string;
  title: string;
  description?: string;
  order: number;
  status: string;
  type: string;
}

const CurriculumFolder = ({ item, language }: CurriculumFolderProps) => {
  const [folderOpen, setFolderOpen] = useState(false);

  return item ? (
    <div key={item._id}>
      {!folderOpen ? (
        <div className="folderWrapper d-flex">
          <div className="d-flex flex-column folderInternalWrapper">
            <div className="d-flex">
              <FolderIcon />
              <div className={`folderTitle ${language === "Hebrew" ? "alignRight mr-3" : "ml-3"}`} onClick={(e) => setFolderOpen(!folderOpen)}>
                {item.title}
              </div>
            </div>
            <div className={`folderDescription ${language === "Hebrew" ? "alignRight" : null}`}>
              <div>{item.description}</div>
            </div>
          </div>
          <ArrowDownIcon className="arrowDownIcon" onClick={(e) => setFolderOpen(!folderOpen)} />
        </div>
      ) : (
        <div className="folderWrapper folderWrapperOpened d-flex flex-column">
          <div className="d-flex flex-column folderInternalWrapper folderInternalWrapperOpened" onClick={(e) => setFolderOpen(!folderOpen)}>
            <div className="d-flex">
              <FolderOpenIcon />
              <div className={`folderTitle ${language === "Hebrew" ? "alignRight mr-3" : "ml-3"}`}>{item.title}</div>
            </div>
          </div>
          <div className="fileListWrapper">
            {item.contentItems.map((item: IContentItem) => {
              return <CurriculumCI item={item} key={item._id} mode={"insideFolder"} language={language} />;
            })}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div>None</div>
  );
};

export default CurriculumFolder;
